import { render, staticRenderFns } from "./CompanyAttributes.vue?vue&type=template&id=deb3bc54&scoped=true&"
import script from "./CompanyAttributes.vue?vue&type=script&lang=js&"
export * from "./CompanyAttributes.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAttributes.vue?vue&type=style&index=0&id=deb3bc54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb3bc54",
  null
  
)

export default component.exports